














































import Vue from "vue";
import CreateReceiverForm from "./wizard/CreateReceiverForm.vue";
import ReceiverDeliveryForm from "./wizard/ReceiverDeliveryForm.vue";
import CreateReceiverAddress from "./wizard/CreateReceiverAddress.vue";
import WizardTab from "../../../components/black_dashboard_pro/Wizard/WizardTab.vue";
import SimpleWizard from "../../../components/black_dashboard_pro/Wizard/Wizard.vue";
import { ValidationObserver } from "vee-validate";

export default Vue.extend({
  name: "create-receivers-page",
  components: {
    CreateReceiverForm,
    ReceiverDeliveryForm,
    CreateReceiverAddress,
    //@ts-ignore
    SimpleWizard,
    //@ts-ignore
    WizardTab,
  },
  data() {
    return {
      receiverId: null as string | null,
    };
  },
  methods: {
    validateStep(ref: string) {
      return (
        this.$refs[ref] as InstanceType<typeof ValidationObserver>
      ).validate();
    },
    onReceiverData(receiverId: string) {
      this.receiverId = receiverId;
    },
  },
});
